import { render, staticRenderFns } from "./BlocoAreaPlantadaProdutividadeMonitoramentoAgricola.vue?vue&type=template&id=b3aef23a&scoped=true&lang=pug"
import script from "./BlocoAreaPlantadaProdutividadeMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoAreaPlantadaProdutividadeMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoAreaPlantadaProdutividadeMonitoramentoAgricola.vue?vue&type=style&index=0&id=b3aef23a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aef23a",
  null
  
)

export default component.exports